import * as excepciones from './excepciones';
import * as windowUtils from '@/library/utils/window';

export class Notificador {
	constructor() {
		// Evitar instanciación
		if(this.constructor === Notificador) {
			throw new excepciones.ErrorInstanciacion('Notificador'); 
		}
		// Verificar que métodos estén implementados
		if(this.notificar === undefined) {
			throw new excepciones.MetodoNoImplementado('notificar', 'Notificador'); 
		}
	}
}

export class NotificadorServiceWorker extends Notificador {
	constructor(registroServiceWorker) {
		super();
		if(registroServiceWorker === undefined) {
			throw new excepciones.NoHayRegistroServiceWorker();
		}
		this.registroServiceWorker = registroServiceWorker;
	}
	notificar(titulo, mensaje) {
		try {
			const opciones = {
				'body': mensaje,
			};
			this.registroServiceWorker.showNotification(titulo, opciones);
		}
		catch(e) {
			throw new excepciones.ErrorNotificacion();
		}
	}
}

export class NotificadorAppEBoletaAndroid extends Notificador {
	constructor() {
		super();
		if(!this.constructor.windowTieneAndroid()) {
			throw new excepciones.WindowNoTieneAndroid();
		}
	}
	notificar(titulo, mensaje) {
		try {
			let subtexto = undefined;
			window.Android.showNotification(titulo, mensaje, subtexto);
		}
		catch(e) {
			throw new excepciones.ErrorNotificacion();
		}
	}
	static windowTieneAndroid() {
		/* La app de e-Boleta para Android usa WebView. Al 02-nov-2020 el WebView NO SOPORTA notificaciones con ServiceWorker.
		   La solución fue propuesta por rroman: inyectar un objeto artificial a window (window.Android), el que contiene una 
		   función que permite invocar las notificaciones de Android directamente. Función en WebView implementada por rarmijo. */ 
		let tiene = windowUtils.windowHasAndroid();
		return tiene;
	}
}
